import React from 'react';
import styles from './BadgeCounter.module.scss';

export type Size = 'normal' | 'small'

type Props = {
    total: number,
    className?: string,
    size?: Size
};

const BadgeCounter: React.FC<Props> = ({ total, className, size }: Props) => {
    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.subContainer}>
                <span className={`${styles.counter} ${size === 'small' ? styles.counterSmall : ''}`}>
                    {total > 99 ? '99+' : total}
                </span>
            </div>
        </div>
    );
}

export default BadgeCounter;
